import React from 'react'
import PrivacyComp from '../Components/privacysection/PrivacyComp'

function Privacy() {
  return (
    <>
    <PrivacyComp />
    
    </>
  )
}

export default Privacy